import { createSlice } from "@reduxjs/toolkit";

const initialWarehousesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  storages: [],
  storagesTotalCount: 0,
  lastError: null,
  error: null,
  description: null,
  completed: false,
  warehouseOneForStockTransfer: null,
  warehouseTwoForStockTransfer: null,
  warehousesForExport: null,
  message: {
    error: null,
    success: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const warehousesSlice = createSlice({
  name: "warehouses",
  initialState: initialWarehousesState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors[0] : action.payload.error.errors[0];
      if (error?.constructor?.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.message.error = null;
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    warehouseCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities = [action.payload.warehouse, ...state.entities];
      state.message.success = action.payload.message;
      state.completed = true;
    },
    // updatewarehouse
    warehouseUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      const { entity, message } = action.payload;
      state.entities = state.entities.map((item) => {
        if (item.id === entity.id) {
          item = entity;
        }
        return item;
      });
      state.message.success = message;
      state.completed = true;
    },
    // deletewarehouse
    warehouseDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      const { message, id } = action.payload;
      state.entities = state.entities.filter((el) => el.id !== Number(id));
      state.message.success = message;
    },

    //warehouse description
    setWarehouseDescription: (state, action) => {
      state.description = action.payload.description;
    },
    //warehouse description
    changeCompleteStatus: (state, action) => {
      state.message.success = null;
      state.completed = action.payload.status;
    },

    // deletewarehouses
    warehousesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter((el) => !action.payload.ids.includes(el.id));
    },
    // warehousesUpdateState
    warehousesStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map((entity) => {
        if (ids.findIndex((id) => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
    warehouseFetched: (state, action) => {
      const { totalCount, entities, warehousesForExport } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = totalCount;
      state.entities = entities;
      state.warehousesForExport = warehousesForExport;
    },
    storagesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      if (action.payload.optionalIdForExtraWarehouseObjects == 1) {
        state.warehouseOneForStockTransfer = entities;
      } else if (action.payload.optionalIdForExtraWarehouseObjects == 2) {
        state.warehouseTwoForStockTransfer = entities;
      }

      state.listLoading = false;
      state.error = null;
      state.storagesTotalCount = totalCount;
      state.storages = entities;
    },
    warehousesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      if (action.payload.optionalIdForExtraWarehouseObjects == 1) {
        state.warehouseOneForStockTransfer = entities;
      } else if (action.payload.optionalIdForExtraWarehouseObjects == 2) {
        state.warehouseTwoForStockTransfer = entities;
      }

      state.listLoading = false;
      state.error = null;
      state.totalCount = totalCount;
      state.entities = entities;
    },
    storagesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      if (action.payload.optionalIdForExtraWarehouseObjects == 1) {
        state.warehouseOneForStockTransfer = entities;
      } else if (action.payload.optionalIdForExtraWarehouseObjects == 2) {
        state.warehouseTwoForStockTransfer = entities;
      }

      state.listLoading = false;
      state.error = null;
      state.storagesTotalCount = totalCount;
      state.storages = entities;
    },
    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
      }
    },
  },
});
